import { gql } from '@apollo/client';

// --- Queries ---

export const MONITORING_ALERT_RULES_QUERY = gql`
  query MonitoringAlertRules(
    $first: Int
    $after: String
    $query: QueryMonitoringAlertRuleInput
    $sort: MonitoringAlertRuleSort
  ) {
    monitoringAlertRules(first: $first, after: $after, query: $query, sort: $sort) {
      page {
        edges {
          cursor
          node {
            _id
            name
            emails
            timezone
            rule
            reminder
            currentType
            isActive
            currentDeviceIds
            currentDeviceNames
            currentTags
            teamId
            createdBy
            createdAt
            lastUpdatedDate
            activeHoursEnabled
            activeDays
            activeFrom
            activeTo
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      pageData {
        total
      }
    }
  }
`;

export const MONITORING_ALERT_RULE_QUERY = gql`
  query MonitoringAlertRule($_id: String!) {
    monitoringAlertRule(_id: $_id) {
      _id
      name
      emails
      timezone
      rule
      reminder
      currentType
      isActive
      currentDeviceIds
      currentTags
      teamId
      createdBy
      createdAt
      lastUpdatedDate
      activeHoursEnabled
      activeDays
      activeFrom
      activeTo
    }
  }
`;

// --- Mutations ---

export const CREATE_MONITORING_ALERT_RULE = gql`
  mutation CreateMonitoringAlertRule($input: CreateMonitoringAlertRuleInput!) {
    createMonitoringAlertRule(input: $input) {
      _id
      name
      emails
      timezone
      rule
      reminder
      currentType
      isActive
      currentDeviceIds
      currentTags
      createdAt
      lastUpdatedDate
      activeHoursEnabled
      activeDays
      activeFrom
      activeTo
    }
  }
`;

export const UPDATE_MONITORING_ALERT_RULE = gql`
  mutation UpdateMonitoringAlertRule($input: UpdateMonitoringAlertRuleInput!) {
    updateMonitoringAlertRule(input: $input) {
      _id
      name
      emails
      timezone
      rule
      reminder
      currentType
      isActive
      currentDeviceIds
      currentTags
      createdAt
      lastUpdatedDate
      activeHoursEnabled
      activeDays
      activeFrom
      activeTo
    }
  }
`;

export const DELETE_MONITORING_ALERT_RULE = gql`
  mutation DeleteMonitoringAlertRule($_id: String!) {
    deleteMonitoringAlertRule(_id: $_id)
  }
`;

export const TOGGLE_MONITORING_ALERT_RULE_ACTIVE = gql`
  mutation ToggleMonitoringAlertRuleActive($_id: String!, $isActive: Boolean!) {
    toggleMonitoringAlertRuleActive(_id: $_id, isActive: $isActive) {
      _id
      isActive
      lastUpdatedDate
    }
  }
`;
